import { useState } from "react";
import { Body } from "@sprout/typography.tsx";
import { PrimaryButton, SecondaryButton } from "@sprout/buttons";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog.tsx";
import useTranslation from "@hooks/use_translation.ts";
import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companyName: string;
  emailPreferencesPath: string;
  onDismiss: () => void;
};

export const EnableAlertsModal = ({
  open,
  onOpenChange,
  companyName,
  emailPreferencesPath,
  onDismiss,
}: Props) => {
  const { t } = useTranslation("jobAlerts");
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleTurnOn = async () => {
    setIsSubmitting(true);
    try {
      await axios.patch(emailPreferencesPath, {
        email_preference: { unsubscribe_job_alerts: false },
      });
      await queryClient.invalidateQueries({ queryKey: ["subscriptions"] });
      onDismiss();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="leading-[1.5rem]">
            <span>{t("paused.modal.title")}</span>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <Body>{t("paused.modal.body", { companyName })}</Body>
        </DialogDescription>
        <DialogFooter>
          <SecondaryButton onClick={onDismiss}>{t("paused.modal.notNow")}</SecondaryButton>
          <PrimaryButton onClick={handleTurnOn} loading={isSubmitting}>
            {t("paused.modal.turnOn")}
          </PrimaryButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
